import Container from "react-bootstrap/Container";
import { NavLink, useNavigate } from "react-router-dom";
import "./Navbar.scss";
import { useState, useRef } from "react";
import { Col, Row } from "react-bootstrap";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import FacebookIcon from "@mui/icons-material/Facebook";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { HashLink } from "react-router-hash-link";
import CustomButton from "../../shared/custom-button/custom-button";
import AppsIcon from "@mui/icons-material/Apps";
import CloseIcon from "@mui/icons-material/Close";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

function CustomNavbar() {
  const navigate = useNavigate();

  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isDropdownActive, setIsDropdownActive] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);
  const [industriesOpen, setIndustriesOpen] = useState(false);
  const [disableHover, setDisableHover] = useState(false);

  const handleLinkClick = () => {
    setIsDropdownActive(false);
    setDisableHover(true);
    // Re-enable hover after a short delay so the user can use the menu again later
    setTimeout(() => {
      setDisableHover(false);
    }, 500);
  };

  return (
    <>
      {/* <div
        style={{
          height: "24px",
          width: "24px",
          borderRadius: "100%",
          background: "linear-gradient(to top, transparent, white)",
          position: "absolute",
          left: "9.2%",
          top: "4px",
          zIndex: 200000,
          rotate: "20deg",
        }}
      ></div> */}
      <div
        className={`body-overlay ${
          isDropdownActive || sidebarOpen ? "show" : ""
        }`}
        onClick={() => setSidebarOpen(false)}
      ></div>
      {/* Sidebar navigation sart */}
      <div className="sidebar-navigation">
        <ul className={`menu ${sidebarOpen ? "show" : ""}`}>
          <div className="sidebar-header">
            <img
              src="/amicus-logo.png"
              alt="Logo"
              className="sidebar-logo"
              onClick={() => {
                navigate("/");
                setSidebarOpen(false);
              }}
            />
            <span
              className="close-sidebar"
              onClick={() => setSidebarOpen(false)}
            >
              <CloseIcon />
            </span>
          </div>

          <div className="sidebar-scroll-content">
            {/* Card 1: Navigation - Mobile only */}
            <div className="sidebar-card nav-card mobile-only-card">
              <ul className="sidebar-nav-list">
                <li
                  onClick={() => {
                    navigate("/");
                    setSidebarOpen(false);
                  }}
                >
                  Home
                </li>
                <li
                  onClick={() => {
                    navigate("/company");
                    setSidebarOpen(false);
                  }}
                >
                  About Us
                </li>

                {/* Services Dropdown */}
                <li
                  className={`has-dropdown ${servicesOpen ? "active" : ""}`}
                  onClick={() => setServicesOpen(!servicesOpen)}
                >
                  <span>Our Services</span>
                  <ExpandMoreIcon
                    className={`dropdown-icon ${servicesOpen ? "rotate" : ""}`}
                  />
                </li>
                {servicesOpen && (
                  <ul className="sidebar-submenu">
                    <li
                      onClick={() => {
                        navigate("/services/management-consulting");
                        setSidebarOpen(false);
                      }}
                    >
                      Management Consulting
                    </li>
                    <li
                      onClick={() => {
                        navigate("/services/business-diagnostic");
                        setSidebarOpen(false);
                      }}
                    >
                      Business Diagnostics
                    </li>
                    <li
                      onClick={() => {
                        navigate("/services/business-transformation");
                        setSidebarOpen(false);
                      }}
                    >
                      Business Transformation
                    </li>
                    <li
                      onClick={() => {
                        navigate("/services/cfo-services");
                        setSidebarOpen(false);
                      }}
                    >
                      CFO Services
                    </li>
                    <li
                      onClick={() => {
                        navigate("/services/ipo-project-management");
                        setSidebarOpen(false);
                      }}
                    >
                      IPO Project Management
                    </li>
                    <li
                      onClick={() => {
                        navigate(
                          "/services/project-feasibility-and-strategy-report",
                        );
                        setSidebarOpen(false);
                      }}
                    >
                      Detailed Project & Research Reports
                    </li>
                    <li
                      onClick={() => {
                        navigate("/services/startup-advisory");
                        setSidebarOpen(false);
                      }}
                    >
                      Startup Advisory
                    </li>
                    <li
                      onClick={() => {
                        navigate("/services/fund-advisory");
                        setSidebarOpen(false);
                      }}
                    >
                      Fund Advisory
                    </li>
                    <li
                      onClick={() => {
                        navigate("/services/transaction-advisory");
                        setSidebarOpen(false);
                      }}
                    >
                      Transaction Advisory
                    </li>
                    <li
                      onClick={() => {
                        navigate("/services/human-capital");
                        setSidebarOpen(false);
                      }}
                    >
                      Human Capital
                    </li>
                  </ul>
                )}

                {/* Industries Dropdown */}
                <li
                  className={`has-dropdown ${industriesOpen ? "active" : ""}`}
                  onClick={() => setIndustriesOpen(!industriesOpen)}
                >
                  <span>Industries</span>
                  <ExpandMoreIcon
                    className={`dropdown-icon ${
                      industriesOpen ? "rotate" : ""
                    }`}
                  />
                </li>
                {industriesOpen && (
                  <ul className="sidebar-submenu">
                    <li
                      onClick={() => {
                        navigate("/industries/logistics-consulting-advisory");
                        setSidebarOpen(false);
                      }}
                    >
                      Logistics
                    </li>
                    <li
                      onClick={() => {
                        navigate("/industries/ecommerce-consulting-advisory");
                        setSidebarOpen(false);
                      }}
                    >
                      Ecommerce
                    </li>
                    <li
                      onClick={() => {
                        navigate("/industries/retail-consulting-advisory");
                        setSidebarOpen(false);
                      }}
                    >
                      Retail
                    </li>
                    <li
                      onClick={() => {
                        navigate(
                          "/industries/manufacturing-consulting-advisory",
                        );
                        setSidebarOpen(false);
                      }}
                    >
                      Manufacturing
                    </li>
                    <li
                      onClick={() => {
                        navigate("/industries/hospitality-consulting-advisory");
                        setSidebarOpen(false);
                      }}
                    >
                      Hospitality
                    </li>
                    <li
                      onClick={() => {
                        navigate("/industries/edtech-consulting-advisory");
                        setSidebarOpen(false);
                      }}
                    >
                      EdTech
                    </li>
                  </ul>
                )}

                <li
                  onClick={() => {
                    navigate("/report");
                    setSidebarOpen(false);
                  }}
                >
                  Reports
                </li>
                <li
                  onClick={() => {
                    navigate("/grow-trees");
                    setSidebarOpen(false);
                  }}
                >
                  Sustainability
                </li>
              </ul>
              <CustomButton
                variant="primary"
                className="w-100 sidebar-cta"
                onClick={() => {
                  navigate("/contact");
                  setSidebarOpen(false);
                }}
              >
                Request a Consultation
              </CustomButton>
            </div>

            {/* Card 2: Sustainability */}
            <div className="sidebar-card info-card">
              <h4 className="section-title">
                Committed to a Sustainable Future
              </h4>
              <div className="section-image-wrapper">
                <img
                  src="/images/navbar/sustainable-future.webp"
                  alt="Sustainability"
                />
              </div>
              <p className="section-desc">
                At Amicus Growth Advisors, sustainability drives responsible
                growth and long-term value through focused environmental
                initiatives and partnerships.
              </p>
              <button
                className="section-btn"
                onClick={() => {
                  navigate("/grow-trees");
                  setSidebarOpen(false);
                }}
              >
                Be Part of the Green Movement
              </button>
            </div>

            {/* Card 3: Career */}
            <div className="sidebar-card info-card">
              <h4 className="section-title">Careers</h4>
              <div className="section-image-wrapper">
                <img src="/images/navbar/careers.webp" alt="Career" />
              </div>
              <p className="section-desc">
                Work closely with leaders, solve meaningful problems, and grow
                through hands-on advisory experience.
              </p>
              <button
                onClick={() => {
                  navigate("/career");
                  setSidebarOpen(false);
                }}
                className="section-btn"
              >
                View Open Roles
              </button>
            </div>

            {/* Card 4: Follow Us */}
            <div className="sidebar-card follow-card">
              <div className="follow-wrapper">
                <h4 className="follow-title">Follow Us</h4>
                <div className="social-grid">
                  <a
                    href="https://www.linkedin.com/company/amicus-insolvency-turnaround-services-llp/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <LinkedInIcon />
                  </a>
                  <a
                    href="https://www.facebook.com/AmicusGrowthAdvisors/?paipv=0&eav=AfbVy0HUisgOYqeVZnLZlWZnBJYfraFZdxg8bx7hTcgoveDWeUkxXNsm7dHWBR8YuDI&_rdr"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <FacebookIcon />
                  </a>
                  <a
                    href="https://www.instagram.com/amicusgrowthadvisors/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <InstagramIcon />
                  </a>
                  <a
                    href="whatsapp://send?phone=+919820075360"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <WhatsAppIcon />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </ul>
      </div>
      {/* Sidebar navigation end */}

      {/* main navigation start  */}
      <nav className="navbar navbar-expand-md navbar-light main-navbar fixed-top py-0">
        <div className="container p-0">
          <div>
            <a
              className="navbar-brand pb-2"
              onClick={() => {
                navigate("/");
              }}
            >
              <img
                src="/amicus-logo.png"
                alt="Amicus-Logo"
                className="img-fluid"
                style={{
                  paddingTop: "2px",
                  cursor: "pointer",
                  color: "#151515",
                }}
              />{" "}
              {/* <p className="tagline">
                Your Growth <br /> Partner
              </p> */}
            </a>
          </div>

          <div
            className="collapse navbar-collapse justify-content-center menu--main"
            id="navbarNavDropdown"
          >
            <ul className="navbar-nav">
              <li className="nav-item">
                <a
                  className="nav-link"
                  onClick={() => {
                    navigate("/");
                  }}
                >
                  Home
                </a>
              </li>
              <li className="nav-item active">
                <a
                  className="nav-link"
                  onClick={() => {
                    navigate("/company");
                  }}
                >
                  About Us
                </a>
              </li>
              <li
                className={`nav-item dropdown services-mm megamenu ${disableHover ? 'disable-hover' : ''}`}
                onMouseEnter={() => !disableHover && setIsDropdownActive(true)}
                onMouseLeave={() => setIsDropdownActive(false)}
              >
                <a
                  className="nav-link dropdown-toggle"
                  href="#"
                  id="navbarDropdownMenuLink"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  Our Services <KeyboardArrowDownIcon />
                </a>
                <ul
                  style={{
                    marginTop: "20px",
                  }}
                  className={`dropdown-menu ${isDropdownActive ? "show-menu" : ""}`}
                  aria-labelledby="navbarDropdownMenuLink"
                  onClick={handleLinkClick}
                >
                  <Container className="border-0 p-0 overflow-hidden">
                    <Row className="g-0 justify-content-between">
                      <Col md={7} className="ps-4 py-4">
                        <Row className="gy-4">
                          <Col md={6}>
                            <div className="service-item-wrapper">
                              <div className="service-icon-box">
                                <img
                                  src="/icons/navbar/management.svg"
                                  alt="Management Consulting"
                                  width="24"
                                  height="24"
                                />
                              </div>
                              <HashLink
                                smooth
                                to="/services/management-consulting"
                                className="service-item-text"
                                onClick={handleLinkClick}
                              >
                                Management Consulting
                              </HashLink>
                            </div>
                            <div className="service-item-wrapper">
                              <div className="service-icon-box">
                                <img
                                  src="/icons/navbar/business-diagnostic.svg"
                                  alt="Business Diagnostics"
                                  width="24"
                                  height="24"
                                />
                              </div>
                              <HashLink
                                smooth
                                to="/services/business-diagnostic"
                                className="service-item-text"
                                onClick={handleLinkClick}
                              >
                                Business Diagnostics
                              </HashLink>
                            </div>
                            <div className="service-item-wrapper">
                              <div className="service-icon-box">
                                <img
                                  src="/icons/navbar/business-transformation.svg"
                                  alt="Business Transformation"
                                  width="24"
                                  height="24"
                                />
                              </div>
                              <HashLink
                                smooth
                                to="/services/business-transformation"
                                className="service-item-text"
                                onClick={handleLinkClick}
                              >
                                Business Transformation
                              </HashLink>
                            </div>
                            <div className="service-item-wrapper">
                              <div className="service-icon-box">
                                <img
                                  src="/icons/navbar/cfo-service.svg"
                                  alt="CFO Services"
                                  width="24"
                                  height="24"
                                />
                              </div>
                              <HashLink
                                smooth
                                to="/services/cfo-services"
                                className="service-item-text"
                                onClick={handleLinkClick}
                              >
                                CFO Services
                              </HashLink>
                            </div>
                            <div className="service-item-wrapper">
                              <div className="service-icon-box">
                                <img
                                  src="/icons/navbar/transcation-advisory.svg"
                                  alt="IPO Project Management"
                                  width="24"
                                  height="24"
                                />
                              </div>
                              <HashLink
                                smooth
                                to="/services/ipo-project-management"
                                className="service-item-text"
                                onClick={handleLinkClick}
                              >
                                IPO Project Management
                              </HashLink>
                            </div>
                          </Col>
                          <Col md={6}>
                            <div className="service-item-wrapper">
                              <div className="service-icon-box">
                                <img
                                  src="/icons/navbar/project-feasibility.svg"
                                  alt="Project Feasibility"
                                  width="24"
                                  height="24"
                                />
                              </div>
                              <HashLink
                                smooth
                                to="/services/project-feasibility-and-strategy-report"
                                className="service-item-text"
                                onClick={handleLinkClick}
                              >
                                Detailed Project Reports
                              </HashLink>
                            </div>
                            <div className="service-item-wrapper">
                              <div className="service-icon-box">
                                <img
                                  src="/icons/navbar/startup-advisory.svg"
                                  alt="Startup Advisory"
                                  width="24"
                                  height="24"
                                />
                              </div>
                              <HashLink
                                smooth
                                to="/services/startup-advisory"
                                className="service-item-text"
                                onClick={handleLinkClick}
                              >
                                Startup Advisory
                              </HashLink>
                            </div>
                            <div className="service-item-wrapper">
                              <div className="service-icon-box">
                                <img
                                  src="/icons/navbar/fund-advisory.svg"
                                  alt="Fund Advisory"
                                  width="24"
                                  height="24"
                                />
                              </div>
                              <HashLink
                                smooth
                                to="/services/fund-advisory"
                                className="service-item-text"
                                onClick={handleLinkClick}
                              >
                                Fund Advisory
                              </HashLink>
                            </div>
                            <div className="service-item-wrapper">
                              <div className="service-icon-box">
                                <img
                                  src="/icons/navbar/transcation-advisory.svg"
                                  alt="Transaction Advisory"
                                  width="24"
                                  height="24"
                                />
                              </div>
                              <HashLink
                                smooth
                                to="/services/transaction-advisory"
                                className="service-item-text"
                                onClick={handleLinkClick}
                              >
                                Transaction Advisory
                              </HashLink>
                            </div>
                            <div className="service-item-wrapper">
                              <div className="service-icon-box">
                                <img
                                  src="/icons/navbar/human-capital.svg"
                                  alt="Human Capital"
                                  width="24"
                                  height="24"
                                />
                              </div>
                              <HashLink
                                smooth
                                to="/services/human-capital"
                                className="service-item-text"
                                onClick={handleLinkClick}
                              >
                                Human Capital
                              </HashLink>
                            </div>
                          </Col>
                        </Row>
                      </Col>

                      <Col md={5} className="megamenu-featured-col">
                        <div className="megamenu-featured-card">
                          <img
                            src="/images/navbar/services-header.webp"
                            alt="Services"
                            className="featured-image"
                          />
                          <div className="featured-overlay">
                            <p>
                              All of our services hinge around our promise of
                              delivering brand awareness.
                            </p>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Container>
                </ul>
              </li>
              <li
                className={`nav-item dropdown industries-mm megamenu ${disableHover ? 'disable-hover' : ''}`}
                onMouseEnter={() => !disableHover && setIsDropdownActive(true)}
                onMouseLeave={() => setIsDropdownActive(false)}
              >
                <a
                  className="nav-link dropdown-toggle"
                  href="#"
                  id="navbarDropdownMenuLink"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  Industries <KeyboardArrowDownIcon />
                </a>
                <ul
                  style={{
                    marginTop: "20px",
                    zIndex: 10,
                  }}
                  className={`dropdown-menu ${isDropdownActive ? "show-menu" : ""}`}
                  aria-labelledby="navbarDropdownMenuLink"
                  onClick={handleLinkClick}
                >
                  <Container className="border-0 p-0 overflow-hidden">
                    <Row className="g-0 justify-content-between">
                      <Col md={7} className="ps-4 py-4">
                        <Row className="gy-4">
                          <Col md={6}>
                            <div className="service-item-wrapper">
                              <div className="service-icon-box">
                                <img
                                  src="/icons/navbar/logistics.svg"
                                  alt="Logistics"
                                  width="24"
                                  height="24"
                                />
                              </div>
                              <NavLink
                                to="/industries/logistics-consulting-advisory"
                                className="service-item-text"
                                onClick={handleLinkClick}
                              >
                                Logistics
                              </NavLink>
                            </div>
                            <div className="service-item-wrapper">
                              <div className="service-icon-box">
                                <img
                                  src="/icons/navbar/ecommerce.svg"
                                  alt="Ecommerce"
                                  width="24"
                                  height="24"
                                />
                              </div>
                              <NavLink
                                to="/industries/ecommerce-consulting-advisory"
                                className="service-item-text"
                                onClick={handleLinkClick}
                              >
                                Ecommerce
                              </NavLink>
                            </div>
                            <div className="service-item-wrapper">
                              <div className="service-icon-box">
                                <img
                                  src="/icons/navbar/retail.svg"
                                  alt="Retail"
                                  width="24"
                                  height="24"
                                />
                              </div>
                              <NavLink
                                to="/industries/retail-consulting-advisory"
                                className="service-item-text"
                                onClick={handleLinkClick}
                              >
                                Retail
                              </NavLink>
                            </div>
                          </Col>
                          <Col md={6}>
                            <div className="service-item-wrapper">
                              <div className="service-icon-box">
                                <img
                                  src="/icons/navbar/management.svg"
                                  alt="Manufacturing"
                                  width="24"
                                  height="24"
                                />
                              </div>
                              <NavLink
                                to="/industries/manufacturing-consulting-advisory"
                                className="service-item-text"
                                onClick={handleLinkClick}
                              >
                                Manufacturing
                              </NavLink>
                            </div>
                            <div className="service-item-wrapper">
                              <div className="service-icon-box">
                                <img
                                  src="/icons/navbar/hospitality.svg"
                                  alt="Hospitality"
                                  width="24"
                                  height="24"
                                />
                              </div>
                              <NavLink
                                to="/industries/hospitality-consulting-advisory"
                                className="service-item-text"
                                onClick={handleLinkClick}
                              >
                                Hospitality
                              </NavLink>
                            </div>
                            <div className="service-item-wrapper">
                              <div className="service-icon-box">
                                <img
                                  src="/icons/navbar/ed-tech.svg"
                                  alt="EdTech"
                                  width="24"
                                  height="24"
                                />
                              </div>
                              <NavLink
                                to="/industries/edtech-consulting-advisory"
                                className="service-item-text"
                                onClick={handleLinkClick}
                              >
                                EdTech
                              </NavLink>
                            </div>
                          </Col>
                        </Row>
                      </Col>

                      <Col md={5} className="megamenu-featured-col">
                        <div className="megamenu-featured-card">
                          <img
                            src="/images/navbar/industries-header.webp"
                            alt="Services"
                            className="featured-image"
                          />
                          <div className="featured-overlay">
                            <p>
                              Helping businesses across diverse sectors achieve
                              clarity and growth.
                            </p>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Container>
                </ul>
              </li>
              {/* <li className="nav-item">
                <a
                  className="nav-link"
                  onClick={() => {
                    navigate("/blog");
                  }}
                >
                  Blog
                </a>
              </li> */}
              <li className="nav-item">
                <a
                  className="nav-link"
                  onClick={() => {
                    navigate("/report");
                  }}
                >
                  Reports
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link"
                  onClick={() => {
                    navigate("/grow-trees");
                  }}
                >
                  Sustainability
                </a>
              </li>

              {/* <li className="nav-item">
                <a
                  className="nav-link"
                  onClick={() => {
                    navigate("/contact");
                  }}
                >
                  Contact
                </a>
              </li> */}
              {/* <li className="nav-item">
                        <a className="nav-link  ms-4"onClick={() => {navigate('/career')}}>Career</a>
                    </li> */}
            </ul>
          </div>
          <div className="navbar-actions">
            <CustomButton
              variant="primary"
              onClick={() => {
                navigate("/contact");
              }}
            >
              Request a Consultation
            </CustomButton>
            <AppsIcon
              sx={{ color: "#1a2b56", cursor: "pointer" }}
              fontSize="large"
              onClick={() => setSidebarOpen(true)}
            />
          </div>
        </div>
      </nav>
    </>
  );
}

export default CustomNavbar;
